export default "__VITE_ASSET__Dtw7qqMf__"